import { computed, Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { UserInfos } from "../../models/user_infos.model";
import { UiFacadeService } from "./ui-facade.service";
import { StatsUserInfos } from "../../models/stats-user-infos.model";

@Injectable({ providedIn: "root" })
export class UiStoreService extends EntityStoreService<
  UserInfos,
  EntityMetadata,
  UserInfosState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      currentUserId: null,
      stats: null,
    });
  }

  getByUserId(userId: string) {
    if (!userId) {
      throw new Error("userId null");
    }
    return computed(() =>
      this.allEntities().find((e) => e.userId === userId) ?? null
    );
  }
}

export interface UserInfosState extends EntityStoreState<UiFacadeService> {
  currentUserId: string;
  stats: StatsUserInfos;
}
